<div [matTooltip]="nickname ? originalName : ''">
  <ng-content></ng-content>
</div>
